import { render, staticRenderFns } from "./PreferentialManagement.vue?vue&type=template&id=488a2594"
import script from "./PreferentialManagement.vue?vue&type=script&lang=js"
export * from "./PreferentialManagement.vue?vue&type=script&lang=js"
import style0 from "./PreferentialManagement.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports